<template>
  <v-btn
    @click="() => downLoadExcel()"
    text
    small
    fab
    color="#757575"
    class="mx-6"
  >
    <v-icon size="28" color="#227447">mdi-file-excel</v-icon>
  </v-btn>
</template>

<script>
import GeneraExcelEmpresa from "./ExcelEmpresa";
import GeneraExcelRif from "./ExcelRif";
export default {
  data() {
    return {};
  },
  props: {
    rows: Array,
    tipodoc: Array,
    cliente: Object,
    orderkey: Boolean,
  },
  methods: {
    downLoadExcel() {
      if (this.orderkey) {
        GeneraExcelEmpresa.methods.generarExcel({
          items: this.rows,
          orderkey: this.orderkey,
          cliente: this.cliente,
          tipodoc: this.tipodoc,
        });
      }else{
        GeneraExcelRif.methods.generarExcel({
          items: this.rows,
          orderkey: this.orderkey,
          cliente: this.cliente,
          tipodoc: this.tipodoc,
        });
      }
    },
  },
};
</script>